module.exports = __webpack_public_path__ + "media/Guitar.f0635e40.mp3";